import PropTypes from "prop-types";
import React from "react";
import Dropzone from "react-dropzone";
import { Trans } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import Confirm from "../../../base/Confirm";
import ListView from "../../../base/ListView";
import ModalToBody from "../../../base/ModalToBody";
import { toImmutable } from "../../../libs/immutable-transformer";
import {
  ajaxErrorHandler,
  defaultCrewProps,
  defaultSuccess
} from "../../../libs/utils";
import { CREW_MEMBERS_ACTIONS } from "../../../redux/crewMembers/actions";
import {
  crewMembersMeta,
  selectActiveCrewMember,
  selectCrewMembers
} from "../../../redux/crewMembers/selectors";
import axiosInstance from "../../../services/api";
import {
  createCrewMember,
  deleteCrewMember,
  getCrewMember,
  getMyCrewMembers,
  updateCrewMember
} from "../../../services/api/crewMembers";
import {
  generateVouchers,
  getRegistration,
  uploadTemplate
} from "../../../services/api/registrations";
import { getSetting } from "../../../services/api/settings";
import { getUsers } from "../../../services/api/users";
import CrewMemberForm from "../../forms/CrewMemberForm";
import AdminSubHeader from "../../layouts/partials/AdminSubheader";
import SendVouchersToCrewMemberButton from "../../shared/crewMembers/SendVouchersToCrewMemberButton";
import CopyBtn from "./partials/CopyBtn";

const fileDownload = require("js-file-download");

class _CompanyCrewCrewMembers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            typeaheadUsers: [],
            selectedUser: [],
            showModal: false,
            registration: undefined,
            isSubmitting: false,
            activeCrewMember: undefined,
            activeUser: undefined,
            baseFilters: toImmutable({
                "page[number]": 1,
                "page[size]": 10,
                sort: "-updated_at",
                include: "user,profile,documents",
                "filter[registration_id]": props.registration.id
            }),
            allowCreation: false
        };

        this._addNewUser = this._addNewUser.bind(this);
        this._closeModal = this._closeModal.bind(this);
        this._handleSubmit = this._handleSubmit.bind(this);
        this._handleDelete = this._handleDelete.bind(this);
        this._handleSearch = this._handleSearch.bind(this);
        this._handleChange = this._handleChange.bind(this);
        this._doneSubmitting = this._doneSubmitting.bind(this);
        this._onDrop = this._onDrop.bind(this);
        this._getCrewMembers = this._getCrewMembers.bind(this);
        this._downloadExcel = this._downloadExcel.bind(this);
        this._sendVouchers = this._sendVouchers.bind(this);
    }

    static propTypes = {
        ...defaultCrewProps,
        deleteCrewMember: PropTypes.func,
        crewMembers: PropTypes.array,
        crewMembersMeta: PropTypes.object,
        history: PropTypes.object
    };

    UNSAFE_componentWillMount() {
        getRegistration(this.props.registration.id, {
            include: "registration-profiles,registration-profiles.profile,company"
        }).then(registration => {
            this.setState({registration});
        });

        this._getCrewMembers();

        if (this.props.match.params.id) {
            this._openEditForCrewId(this.props.match.params.id);
        }

        getSetting("allow_company_user_creation").then(response => {
            this.setState({
                allowCreation: response.value
            });
        });
    }

    _getCrewMembers(filters = this.state.baseFilters) {
        getMyCrewMembers(filters).then(response => {
            this.setState({
                crewMembers: response.data,
                crewMembersMeta: response.meta,
                baseFilters: filters
            });
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.id && !this.props.match.params.id) {
            this._openEditForCrewId(nextProps.match.params.id);
        }

        if (!nextProps.match.params.id && this.props.match.params.id) {
            this._closeModal();
        }
    }

    _closeModal(close = true) {
        if (close) {
            this.props.history.push("/crew/crewmembers");
            this.setState({
                activeUser: undefined,
                activeCrewMember: undefined
            });
            document.body.classList.remove("modal-open");
        } else {
            document.body.classList.add("modal-open");
        }

        this.setState({
            showModal: !close
        });
    }

    _openModal() {
        this._closeModal(false);
    }

    _openEditForCrewId(id) {
        getCrewMember(id)
            .then(response => {
                this.setState({
                    activeCrewMember: response
                });
            })
            .catch(ajaxErrorHandler);
        this._openModal();
    }

    _handleSubmit(values) {
        this.setState({
            isSubmitting: true
        });
        console.log('handleSubmit', values)
        const data = {
            userId: values.userId,
            registrationId: this.props.registration.id,
            profileId: values.profileId,
            // occupationId: values.occupationId,
            allowCombiVouchers: values.allowCombiVouchers ?? false,
            camping: values.camping ?? false,
            days: values.days
        };
        console.log('handleSubmitData', values)

        if (values.occupation && values.occupation !== "") {
            data.occupation = values.occupation;
        }

        if (values.crewMemberId !== "") {
            updateCrewMember(values.crewMemberId, data)
                .then(this._doneSubmitting)
                .catch(ajaxErrorHandler);
        } else {
            createCrewMember(data)
                .then(this._doneSubmitting)
                .catch(ajaxErrorHandler);
        }
    }

    _doneSubmitting() {
        this._getCrewMembers();
        this._closeModal();
        this.setState({
            isSubmitting: false
        });
    }

    _handleDelete(id) {
        Confirm("Are you sure you want to delete this Crew Member?", {
            title: "Delete Crew Member",
            confirmStyle: "btn-danger",
            confirmText: "Delete"
        }).then(
            result => {
                deleteCrewMember(id)
                    .then(response => {
                        this._getCrewMembers();
                    })
                    .catch(ajaxErrorHandler);
            },
            result => {
            }
        );
    }

    _onDrop(acceptedFiles, rejectedFiles) {
        Confirm(
            "Are you sure you want to overwrite all data with the data in the file you are uploading?",
            {
                title: "Upload Crew Members",
                confirmStyle: "btn-danger",
                confirmText: "Import"
            }
        ).then(
            result => {
                acceptedFiles.forEach(file => {
                    let data = new FormData();
                    data.append("excel", file);
                    uploadTemplate(this.state.registration.id, data)
                        .then(response => {
                            this._getCrewMembers();
                            defaultSuccess(
                                "Upload successful, your excel is now being processed. Please check back in a couple of minutes."
                            );
                        })
                        .catch(e => {
                            this.setState({
                                errors: e.response.data
                            });
                        });
                });
            },
            result => {
            }
        );
    }

    _handleSearch(value) {
        getUsers({
            "filter[company_id]": this.props.userCompany.id,
            "filter[name]": value
        }).then(response => {
            this.setState({
                typeaheadUsers: response.data
            });
        });
    }

    _handleChange(value) {
        this.setState({
            selectedUser: value
        });
    }

    _addNewUser(e) {
        e.preventDefault();

        document.body.classList.add("modal-open");

        this.setState({
            showModal: true
        });
    }

    _downloadExcel() {
        const baseUrl = process.env.REACT_APP_API_BASE_URL;
        const id = this.state.registration.id;
        axiosInstance({
            method: "get",
            url: `${baseUrl}registrations/${id}/import-users/download-template`,
            responseType: "blob"
        }).then(response => {
            fileDownload(response.data, "users-import.xlsx");
        });
    }

    _sendVouchers() {
        generateVouchers(this.props.registration.id, {
            priority: true,
            sendVouchers: true
        })
            .then(reponse => {
                defaultSuccess(
                    "Vouchers are being sent. You will receive them in a couple of minutes."
                );
            })
            .catch(ajaxErrorHandler);
    }

    render() {
        const {
            showModal,
            registration,
            activeCrewMember,
            crewMembers,
            crewMembersMeta,
            baseFilters,
            errors,
            allowCreation
        } = this.state;

        if (!registration) {
            return null;
        }

        const {userEvent, userCompany} = this.props;

        const listViewConf = {
            dataSet: crewMembers,
            dataMeta: crewMembersMeta,
            columns: [
                {
                    key: "name",
                    value: "Name",
                    render: crewMembers =>
                        crewMembers.user.firstName + " " + crewMembers.user.lastName
                },
                {
                    key: "profile",
                    value: "Profile",
                    render: crewMembers => crewMembers.profile.name
                },
                {
                    key: "occupation",
                    value: "Function",
                    render: crewMembers => crewMembers.occupation
                },
                {
                    key: "camping",
                    value: "Crew Camping",
                    render: crewMembers => (crewMembers.camping ? "X" : "")
                },
                {
                    key: "documents",
                    value: "",
                    render: crewMember =>
                        crewMember.documents.map(doc => (
                            <i key={doc.id} className="la la-file"/>
                        ))
                }
            ],
            baseFilters,
            filters: [
                {
                    label: "Name",
                    icon: "la-search",
                    type: "text",
                    key: "name_like"
                },
                {
                    label: "Profile",
                    icon: "la-user",
                    key: "profile_id",
                    type: "select",
                    dataset: registration.registrationProfiles.map(({profile}) => {
                        return {
                            key: profile.id,
                            value: profile.name
                        };
                    })
                },
                {
                    label: "Day",
                    key: "for_day",
                    icon: "la-calendar",
                    type: "datepicker"
                }
            ],
            actions: {
                deleteLink: true,
                editLink: true,
                detailsLink: false,
                customLink: item => <SendVouchersToCrewMemberButton crewMember={item}/>,
                deleteFunction: this._handleDelete
            },
            url: "/crew/crewmembers"
        };

        return [
            <AdminSubHeader
                title="Crew - Crew Members"
                key="subheader"
                breadcrumbs={[]}
            />,
            <div className="m-content" key="content">
                {registration && (
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="m-portlet">
                                <div className="m-portlet__head">
                                    <div className="m-portlet__head-caption">
                                        <div className="m-portlet__head-title"/>
                                    </div>

                                    <div className="m-portlet__head-tools">
                                        <form>
                                            {crewMembers &&
                                                crewMembers.length > 0 &&
                                                registration.completedSafetyQuestions && (
                                                    <ul
                                                        className="m-portlet__nav"
                                                        style={{float: "left"}}
                                                    >
                                                        <li className="m-portlet__nav-item">
                                                            <CopyBtn
                                                                company={userCompany}
                                                                event={userEvent}
                                                                registration={registration}
                                                                loadCrewMembers={this._getCrewMembers}
                                                            />
                                                        </li>
                                                    </ul>
                                                )}
                                            <ul className="m-portlet__nav m--margin-left-20">
                                                <ReactTooltip/>
                                                <li
                                                    className="m-portlet__nav-item"
                                                    data-tip={
                                                        registration.completedSafetyQuestions ||
                                                        registration.completedSubcontractors
                                                            ? ""
                                                            : "Please complete Safety Questions and Subcontractors first"
                                                    }
                                                >
                                                    <button
                                                        type="button"
                                                        className="m-portlet__nav-link btn btn-success m-btn m-btn--icon"
                                                        disabled={
                                                            !crewMembers ||
                                                            crewMembers.length === 0 ||
                                                            !registration.completedSafetyQuestions ||
                                                            !registration.completedSubcontractors
                                                        }
                                                        onClick={this._sendVouchers}
                                                    >
                                                        <span>
                                                            <i className="la la-send"/>
                                                            <span>
                                                                <Trans>Send Vouchers</Trans>
                                                            </span>
                                                        </span>
                                                    </button>
                                                </li>
                                                <li
                                                    className="m-portlet__nav-item"
                                                    data-tip={
                                                        registration.completedSafetyQuestions ||
                                                        registration.completedSubcontractors
                                                            ? ""
                                                            : "Please complete Safety Questions and Subcontractors first"
                                                    }
                                                >
                                                    <button
                                                        type="button"
                                                        className="m-portlet__nav-link btn btn-primary m-btn m-btn--icon"
                                                        disabled={
                                                            !registration.completedSafetyQuestions ||
                                                            !registration.completedSubcontractors
                                                        }
                                                        onClick={this._addNewUser}
                                                    >
                                                        <span>
                                                            <i className="la la-plus"/>
                                                            <span>
                                                                <Trans>Add Crew</Trans>
                                                            </span>
                                                        </span>
                                                    </button>
                                                </li>
                                            </ul>
                                        </form>
                                    </div>
                                </div>
                            </div>

                            {errors && (
                                <div className="alert alert-danger">
                                    <h4>Upload failed.</h4>
                                    {Object.entries(errors).map(row => (
                                        <p key={row[0]}>
                                            <strong>Row {row[0]}</strong> <br/>
                                            <ul>
                                                {Object.entries(row[1]).map(error => (
                                                    <li key={error[0]}>{error[1]}</li>
                                                ))}
                                            </ul>
                                        </p>
                                    ))}
                                </div>
                            )}

                            <div className="row">
                                <div
                                    className={
                                        registration.excelImportsAllowed === 1
                                            ? "col-lg-9"
                                            : "col-lg-12"
                                    }
                                >
                                    {crewMembers && crewMembers.length > 0 ? (
                                        <ListView
                                            config={listViewConf}
                                            handleDelete={this._handleDelete}
                                            handleFilterUpdate={this._getCrewMembers}
                                        />
                                    ) : (
                                        <div className="alert alert-info">
                                            <Trans>frontend.crew.noCrewMembersMsg</Trans>
                                        </div>
                                    )}
                                </div>
                                {registration.excelImportsAllowed === 1 && (
                                    <div className="col-lg-3">
                                        <div className="m-portlet">
                                            <div className="m-portlet__head">
                                                <div className="m-portlet__head-caption">
                                                    <div className="m-portlet__head-title">
                                                        <span className="m-portlet__head-icon">
                                                            <i className="la la-file-excel-o"/>
                                                        </span>
                                                        <h3 className="m-portlet__head-text">
                                                            Excell import/export
                                                        </h3>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="m-portlet__body">
                                                {registration && (
                                                    <div>
                                                        {allowCreation ? (
                                                            <div>
                                                                <button
                                                                    className="btn btn-primary btn-block m--margin-bottom-10"
                                                                    onClick={this._downloadExcel}
                                                                >
                                                                    <span className="la la-download"/>
                                                                    Download
                                                                    Template
                                                                </button>
                                                                <Dropzone
                                                                    onDrop={this._onDrop}
                                                                >
                                                                    {({getRootProps}) => <div
                                                                        className="m-dropzone dropzone dz-clickable" {...getRootProps()}>
                                                                        <div
                                                                            className="m-dropzone__msg dz-message needsclick">
                                                                            <h3 className="m-dropzone__msg-title">
                                                                                <Trans>frontend.crew.upload.title</Trans>
                                                                            </h3>
                                                                            <span className="m-dropzone__msg-desc">
                                                                                <Trans>
                                                                                    frontend.crew.upload.description
                                                                                </Trans>
                                                                            </span>
                                                                        </div>
                                                                    </div>}
                                                                </Dropzone>
                                                            </div>
                                                        ) : (
                                                            <div className="alert alert-warning">
                                                                <Trans>creatingNotAllowedMsg</Trans>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
                <ModalToBody>
                    <div
                        className="modal fade show"
                        id="m_modal_4"
                        tabIndex="-1"
                        role="dialog"
                        aria-labelledby="exampleModalLabel"
                        style={{
                            display: showModal ? "block" : "none",
                            zIndex: "1039"
                        }}
                    >
                        <div className="modal-dialog modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel">
                                        {activeCrewMember ? "Edit" : "New"} Crew Member for{" "}
                                        {userEvent.name}
                                    </h5>
                                    <button
                                        type="button"
                                        className="close"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                        onClick={this._closeModal}
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>

                                {showModal && registration && (
                                    <CrewMemberForm
                                        event={userEvent}
                                        registration={registration}
                                        crewMember={activeCrewMember}
                                        close={this._closeModal}
                                        onSubmit={this._handleSubmit}
                                        visible={showModal}
                                        crewMemberId={this.props.match.params.id}
                                    />
                                )}
                            </div>
                        </div>
                    </div>

                    <div
                        className={"modal-backdrop fade " + (showModal ? " show" : "")}
                        style={{
                            display: showModal ? "block" : "none",
                            zIndex: "1038"
                        }}
                    />
                </ModalToBody>
            </div>
        ];
    }
}

const mapDispatchToProps = dispatch => ({
    deleteCrewMember: id => dispatch(CREW_MEMBERS_ACTIONS.deleteRequest(id)),
    loadCrewMembers: () => dispatch(CREW_MEMBERS_ACTIONS.loadAllRequest())
});

const mapStateToProps = function (state) {
    return {
        crewMembers: selectCrewMembers(state),
        crewMembersMeta: crewMembersMeta(state),
        activeCrewMember: selectActiveCrewMember(state)
    };
};

const CompanyCrewCrewMembers = withRouter(
    connect(mapStateToProps, mapDispatchToProps)(_CompanyCrewCrewMembers)
);

export default CompanyCrewCrewMembers;
